import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getItems, addItem, deleteItem, editItem } from "./itemsApi";

export const initialState = {
  items: [],
  isLoding: false,
  isError: false,
  error: "",
  editing: {},
};

// create thunk function

export const fetchItems = createAsyncThunk("itms/fetchItem", async () => {
  const items = await getItems();
  return items;
});
export const newItem = createAsyncThunk("itms/newItem", async (data) => {
  const item = await addItem(data);
  return item;
});
export const changeItem = createAsyncThunk(
  "itms/changeItem",
  async ({ id, data }) => {
    const item = await editItem(id, data);
    return item;
  }
);
export const removeItem = createAsyncThunk("itms/removeItem", async (id) => {
  const item = await deleteItem(id);
  return item;
});

// create slice

const itemSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    editActive: (state, action) => {
      state.editing = action.payload;
    },
    inActive: (state) => {
      state.editing = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchItems.pending, (state) => {
        state.isLoding = true;
        state.isError = false;
      })
      .addCase(fetchItems.fulfilled, (state, action) => {
        state.isLoding = false;
        state.isError = false;
        state.items = action.payload;
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.isLoding = false;
        state.isError = true;
        state.error = action.error.message;
        state.items = [];
      })
      .addCase(newItem.pending, (state) => {
        state.isLoding = true;
        state.isError = false;
      })
      .addCase(newItem.fulfilled, (state, action) => {
        state.isLoding = false;
        state.isError = false;
        state.items.push(action.payload);
      })
      .addCase(newItem.rejected, (state, action) => {
        state.isLoding = false;
        state.isError = true;
        state.error = action.error.message;
      })
      .addCase(changeItem.pending, (state) => {
        state.isLoding = true;
        state.isError = false;
      })
      .addCase(changeItem.fulfilled, (state, action) => {
        state.isLoding = false;
        state.isError = false;
        // state.items.push(action.payload)
        const indexNo = state.items.findIndex(
          (t) => t.id === action.payload.id
        );
        state.items[indexNo] = action.payload;
      })
      .addCase(changeItem.rejected, (state, action) => {
        state.isLoding = false;
        state.isError = true;
        state.error = action.error.message;
      })
      .addCase(removeItem.pending, (state) => {
        state.isLoding = true;
        state.isError = false;
      })
      .addCase(removeItem.fulfilled, (state, action) => {
        state.isLoding = false;
        state.isError = false;
        // state.items.push(action.payload)
        state.items = state.items.filter((t) => t.id !== action.meta.arg);
      })
      .addCase(removeItem.rejected, (state, action) => {
        state.isLoding = false;
        state.isError = true;
        state.error = action.error.message;
      });
  },
});

export default itemSlice.reducer;
export const { editActive, inActive } = itemSlice.actions;
